import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentCategoryComponent } from './document-category.component';
import { AddDocumentCategoryComponent } from './add-document-category/add-document-category.component';
import { EditDocumentCategoryComponent } from './edit-document-category/edit-document-category.component';

import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
	declarations: [
		DocumentCategoryComponent,
		AddDocumentCategoryComponent,
		EditDocumentCategoryComponent
	],
	imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule],
	exports: [DocumentCategoryComponent],
})
export class DocumentCategoryModule { }
